import { Controller } from "@hotwired/stimulus"

// Keeps secondary dashboard streams available without asking phone users to
// scan every passive feed before they can act on their work.
export default class extends Controller {
  static values = { breakpoint: { type: Number, default: 768 } }

  connect() {
    this.media = window.matchMedia(`(min-width: ${this.breakpointValue}px)`)
    this.handleChange = () => this.sync()
    this.media.addEventListener("change", this.handleChange)
    this.sync()
  }

  disconnect() {
    this.media?.removeEventListener("change", this.handleChange)
  }

  sync() {
    this.element.open = this.media.matches
  }
}
